export const logger = values => async dispatch => {
  try {
    if (window.location.hostname === 'localhost') {
      return
    }

    const errorMessage =
      typeof values.error === 'string'
        ? values.error
        : values.error instanceof Error
        ? values.error.stack || values.error.message
        : values.error
        ? JSON.stringify(values.error)
        : 'Unknown error'

    const ignoredErrors = [
      'You must be logged in to do this.',
      'Unexpected token',
      'Incorrect password',
      'Failed to fetch',
    ]

    if (
      errorMessage === '{}' ||
      ignoredErrors.some(msg => errorMessage.includes(msg))
    ) {
      return
    }

    let domain_map = {
      'staging.rolzo.com': 'staging',
      'business.rolzo.com': 'business',
      'book.rolzo.com': 'book',
      'pricing.rolzo.com': 'pricing',
      'demo.rolzo.com': 'demo',
      'partner.rolzo.com': 'partner',
      'partners.rolzo.com': 'partners',
      localhost: 'localhost',
    }
    const timestampNs = `${Date.now() * 1_000_000}`
    const payload = {
      streams: [
        {
          stream: {
            app: 'react-frontend',
            env: domain_map[window.location.hostname],
            level: 'error',
            file: values.fileName,
          },
          values: [[timestampNs, `| ${values.fileName} | ${errorMessage}`]],
        },
      ],
    }

    await fetch('https://demo.rolzo.com/pipedrive/log/push', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
  } catch (err) {
    console.error('Failed to send log to Loki', err)
    return
  }
}
